// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/cnquery_cnspec_actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanAssign } from "./hook";

export type CanAssignProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanAssign({ children, fallback, scope }: CanAssignProps) {
  const canDoAction = useCanAssign(scope);
  return <>{canDoAction ? children : fallback}</>;
}
